<template>
  <div class="slider-ds-popup">
    <div class="slider-item-wrapper mb-5">
      <span class="slider-label">Horizontal</span>
      <input
        ref="range"
        type="range"
        min="-100"
        max="100"
        v-model="currentValueX"
        @input="onInput('x')"
        @change="onChange('x')"
      >
      <span class="slider-label-value">{{currentValueX}}</span>
    </div>

    <div class="slider-item-wrapper mb-5">
      <span class="slider-label">Vertical</span>
      <input
        ref="range"
        type="range"
        min="-100"
        max="100"
        v-model="currentValueY"
        @input="onInput('y')"
        @change="onChange('y')"
      >
      <span class="slider-label-value">{{currentValueY}}</span>
    </div>

    <div class="slider-item-wrapper mb-5">
      <span class="slider-label">Flou</span>
      <input
        ref="range"
        type="range"
        v-model="currentValueBlur"
        @input="onInput('blur')"
        @change="onChange('blur')"
      >
      <span class="slider-label-value">{{currentValueBlur}}</span>
    </div>
    <div class="slider-item-wrapper">
      <span class="slider-label">Opacité</span>
      <input
        ref="range"
        type="range"
        v-model="currentValueOpacity"
        @input="onInput('opacity')"
        @change="onChange('opacity')"
      >
      <span class="slider-label-value">{{currentValueOpacity}}</span>
    </div>
  </div>
</template>
<script>
import { EventBus, TEMPLATE_MODIFIED } from '@/model/EventBus'
import { not, empty, defined } from 'junctions-fp'
export default {
  name: 'SliderDropShadow',
  components: {},
  beforeCreate() {},
  created() {
    this.editor.on('selectedObject', object => {
      this.onSelectedObject(object)
    })
  },
  beforeMount() {},
  mounted() {
    const selected = this.editor.getCurrentSelectedObject()
    if (defined(selected)) {
      this.onSelectedObject(selected)
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      currentValueX: 0,
      currentValueY: 0,
      currentValueBlur: 0,
      currentValueOpacity: 100,
      currentShadow: {
        offsetX: 0,
        offsetY: 0,
        blur: 0,
        color: 'rgba(0,0,0,1)'
      }
    }
  },
  props: {
    editor: null
  },
  computed: {
    getOpacityNumber() {
      if (this.currentShadow) {
        const [, , , alpha] = this.currentShadow.color.match(/\(([^)]+)\)/)[1].split(',')
        return alpha * 100
      }
      return 100
    }
  },
  methods: {
    onInput(type) {
      switch (type) {
        case 'x':
          this.currentShadow.offsetX = Number(this.currentValueX)
          break
        case 'y':
          this.currentShadow.offsetY = Number(this.currentValueY)
          break
        case 'blur':
          this.currentShadow.blur = Number(this.currentValueBlur)
          break
        case 'opacity':
          this.currentShadow.color = `rgba(0,0,0, ${Number(this.currentValueOpacity / 100)})`
          break
      }
      this.editor.addShadow(this.currentShadow)
    },
    onChange(evt, type) {
      this.editor.applyModification()
      EventBus.$emit(TEMPLATE_MODIFIED)
    },
    onSelectedObject({ shadow }) {
      if (shadow) {
        const [, , , alpha] = shadow.color.match(/\(([^)]+)\)/)[1].split(',')

        this.currentValueX = shadow.offsetX
        this.currentValueY = shadow.offsetY
        this.currentValueBlur = shadow.blur
        this.currentValueOpacity = alpha * 100
        this.currentShadow = { offsetX: shadow.offsetX, offsetY: shadow.offsetY, color: shadow.color, blur: shadow.blur }
      }
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/slider/SliderDropShadow.vue